import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { GridSearchIcon } from '@mui/x-data-grid';
import React, { memo } from 'react'
// Memoized Button Component
const CustomIconButton = styled(IconButton)`
  .MuiSvgIcon-root {
  color: ${({ tableBorder }) => tableBorder};
  }
`;
const SearchButton = ({ tableBorder, getSearchResult }) => {

    // console.log("search button rendered");
    return (

        <CustomIconButton size="small" tableBorder={tableBorder} onClick={getSearchResult} >
            <GridSearchIcon />
        </CustomIconButton>
    )
};



export default memo(SearchButton);